var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPalomita(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.79 127.58",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.71 0C29.06-.56-.8 29.44 0 63.74c1 42 34.52 65.2 64.33 63.78 35.07 0 62.3-27.54 63.41-62.11C128.7 35.88 106.47.71 63.71 0zm40 46.36l-47.5 48.47a3.19 3.19 0 01-4.52 0l-8-7.86-18.36-17.89a3.19 3.19 0 01-.06-4.52l9-9.24a3.21 3.21 0 014.53-.06l14.48 14.13a.6.6 0 00.84 0L90 32.84a3.21 3.21 0 014.53 0l9.22 9a3.21 3.21 0 010 4.53z",
    fill: "#1dbfd4",
    "data-name": "Capa 3"
  }))));
}

export default SvgPalomita;